module.exports = __webpack_public_path__ + "static/media/NU.e7e9e4be.svg";